import { useRef, useState } from "react";
import { css } from "styled-components";
import { Modal, media } from "@nested/brand";
import { Expand } from "../../../marketing-site/app/components/VideoControls/VideoControls";

const expandButton = css`
  display: inline-block;
  position: absolute;
  top: 30px;
  right: 30px;
`;

const openModalButtonStyles = css`
  padding: 0;
  border: none;
  outline: none;
  font: inherit;
  color: inherit;
  background: none;
  height: 100%;
  width: 100%;
  cursor: pointer;
  position: relative;
`;

const heroVideoStyles = css`
  width: 100%;
  ${media.desktop`
    object-fit: cover;
    height: 100%;
`}
`;

const modalStyles = css`
  padding: 0;
  background-color: ${({ theme }) => theme.palette.hague80};
  border-radius: 0;
  max-width: 1024px;
  ${media.tablet`
    width: 80%;
  `}
`;

const videoInModal = css`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

export const VideoPlayer = ({ videoLink }) => {
  const [showModal, setShowModal] = useState(false);
  const modalVideoRef = useRef();
  const heroVideoRef = useRef();
  const expandVideo = () => {
    heroVideoRef.current.pause();
    setShowModal(true);
    modalVideoRef.current.play();
  };

  const closeVideo = () => {
    modalVideoRef.current.pause();
    setShowModal(false);
    heroVideoRef.current.play();
  };
  return (
    <>
      {/* eslint-disable-next-line */}
      <div
        css={openModalButtonStyles}
        onClick={expandVideo}
        className="chromatic-ignore"
      >
        <>
          <video
            ref={heroVideoRef}
            css={heroVideoStyles}
            autoPlay
            loop
            playsInline
            muted
          >
            <source src={videoLink} type="video/mp4" />
          </video>
          <Expand css={expandButton} onClick={expandVideo} />
        </>
        <Modal onClose={closeVideo} open={showModal} css={modalStyles}>
          {/* eslint-disable-next-line */}
          <video
            ref={modalVideoRef}
            controls
            autoPlay={showModal}
            css={videoInModal}
            muted={!showModal}
          >
            <source src={videoLink} type="video/mp4" />
          </video>
        </Modal>
      </div>
    </>
  );
};
